const CountdownTimer = (function ($) {
    window.dataLayer = window.dataLayer || [];
    const self = {
        elements: {
            id: {
                days: '#vds-countdown-days',
                hours: '#vds-countdown-hours',
                minutes: '#vds-countdown-minutes',
                seconds: '#vds-countdown-seconds',
                countdownTimer: '#countdown-timer'
            }
        },
        func: {
            init: function () {
                self.func.updateTimer();
                const ms = 1000;
                setInterval(self.func.updateTimer, ms);
            },
            updateTimer: function () {
                const t = self.func.getRemainingTime();

                $(self.elements.id.days).text(t.days);
                const lastTwoCharacters = -2;
                const fillString = '0';
                $(self.elements.id.hours).text((fillString + t.hours).slice(lastTwoCharacters));
                $(self.elements.id.minutes).text((fillString + t.minutes).slice(lastTwoCharacters));
                $(self.elements.id.seconds).text((fillString + t.seconds).slice(lastTwoCharacters));
            },
            getRemainingTime: function () {
                const expiryDate = $(self.elements.id.countdownTimer).data('expirydate');
                const currentDate = new Date();
                const maxLength = 2;
                const fillString = '0';
                const addOne = 1;
                const dd = String(currentDate.getUTCDate()).padStart(maxLength, fillString);
                const mm = String(currentDate.getUTCMonth() + addOne).padStart(maxLength, fillString);
                const yyyy = currentDate.getUTCFullYear();
                const time = currentDate.getUTCHours() + ':' + currentDate.getUTCMinutes() + ':' + currentDate.getUTCSeconds();

                if (new Date(expiryDate) <= new Date(mm + '/' + dd + '/' + yyyy + ' ' + time))
                {
                    $(self.elements.id.countdownTimer).hide();
                }

                const total = Date.parse(new Date(expiryDate)) - Date.parse(mm + '/' + dd + '/' + yyyy + ' ' + time);
                const ms = 1000;
                const secs = 60;
                const hrs = 24;
                const seconds = Math.floor((total / ms) % secs);
                const minutes = Math.floor((total / ms / secs) % secs);
                const hours = Math.floor((total / (ms * secs * secs)) % hrs);
                const days = Math.floor(total / (ms * secs * secs * hrs));

                return {
                    total,
                    days,
                    hours,
                    minutes,
                    seconds
                };
            }
        }
    };
    return {
        init: self.func.init
    };
})(jQuery);

$('document').ready(function () {
    const zero = 0;
    if ($('#countdown-timer').length > zero) {
        CountdownTimer.init();
    }
});
